import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Select } from 'antd';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getFootPrint } from '../../NecttosComp/APICaller/ApiServices';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

const exportPdf = async ({ olddata, setLoading }) => {
	try {
		const { collegeId, method, dateFrom, dateTo } = olddata;

		const instance = await getAxiosTokenInstance();

		const resp = await instance.post('/college/reportGeneration/footPrint', { collegeId, method, dateFrom, dateTo }, { responseType: 'blob' });

		if (resp.data.statusCode === 400) {
			setLoading(false);

			throw new Error(resp.data.message || 'API Error');
		}

		return resp.data;
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const { Option } = Select;
export const FootPrint = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const [loading, setLoading] = useState(false);

	const [isPrinting, setIsPrinting] = useState(false);
	const exportPdfMutation = useMutation(exportPdf);

	const onExportExam = async () => {
		try {
			setLoading(true);

			console.log('==0======>');
			const { method, dateFrom, dateTo } = state;
			const link = document.createElement('a');
			link.target = '_blank';
			link.download = `Foot Print`;

			console.log('==1======>');
			const pdfData = await exportPdfMutation.mutateAsync({ olddata: { collegeId, method, dateFrom, dateTo }, setLoading });

			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));

			link.click();

			setLoading(false);
			onClose();
		} catch (e) {}
	};

	const [state, setState] = useState({
		dateTo: '',
		dateFrom: '',
		method: 'All',
	});

	const { data = [], refetch } = useQuery(['getFootPrint', state.dateFrom, state.dateTo], getFootPrint(collegeId, state.dateFrom, state.dateTo));
	const [isLoading, setIsLoading] = useState(false);

	const [admisionNumber, setAdmisionNumber] = useState('');

	const [student, setStudent] = useState({ name: '', photo: '', class: '' });
	const [showDetails, setShowDetails] = useState(false);

	const filteredData = data.filter((item) => {
		return state.method === 'All' || item.method === state.method;
	});
	const manageDDCSubject = useCallback(async () => {
		try {
			setIsLoading(true);
			const instance = await getAxiosTokenInstance();
			let resp = await instance.post('/college/action/postFootPrint', {
				collegeId,
				admisionNo: admisionNumber,
				method: 'offline',
				type: 'internal',
			});

			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				// Assuming resp.data has student details

				setStudent({
					name: resp?.data?.userIdDoc?.name,
					photo: resp?.data?.userIdDoc?.photoURL,
				});
				setShowDetails(true);
				setTimeout(() => setShowDetails(false), 40000); // hide after 40 seconds

				setAdmisionNumber('');
				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	}, [admisionNumber]);

	useEffect(() => {
		const listener = (event) => {
			if (event.code === 'Enter' || event.code === 'NumpadEnter') {
				event.preventDefault();
				manageDDCSubject();
			}
		};
		document.addEventListener('keydown', listener);
		return () => {
			document.removeEventListener('keydown', listener);
		};
	}, [manageDDCSubject]);

	return (
		<Main width='100%' height='100%' title='PrintsFoots'>
			<Header>
				<div className='flex flex-col sm:flex-row gap-2'>
					<Input width='200px' fieldName='Mode of Entry' options={['All', 'online', 'offline']} returnKey='method' state={state} setState={setState} type='drop' />
					<Input width='200px' fieldName='From Date' returnKey='dateFrom' state={state} setState={setState} type='date' />
					<Input width='200px' fieldName='End Date' returnKey='dateTo' state={state} setState={setState} type='date' />
				</div>

				<div className='flex flex-wrap gap-2 mt-3 sm:mt-0'>
					<Button type='fetch' onClick={refetch}>
						Reload
					</Button>
					{/* <Button type='save' onClick={onExportExam}>
						Download
					</Button> */}
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'footPrint'}/>
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<div className='flex flex-col md:flex-row w-full h-full overflow-hidden'>
			<div className='w-full md:w-2/3'>

					<div className='rounded-xl shadow-lg p-6 space-y-6  '>
						<h2 className='text-2xl font-bold text-center text-gray-800 dark:text-white'>{state.alert || 'Gate Entry'}</h2>

						<div className='flex flex-col items-center'>
							<label htmlFor='admission-number' className='text-md font-semibold text-gray-600 dark:text-gray-300 mb-2'>
								Admission Number
							</label>
							<input id='admission-number' type='number' autoFocus value={admisionNumber} onChange={(e) => setAdmisionNumber(e.target.value)} className='w-52 text-center text-xl font-bold rounded-full px-4 py-2 border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white' />
						</div>

						<div className='flex justify-center gap-4'>
							<Button type='close' onClick={() => setAdmisionNumber('')}>
								Clear
							</Button>
							<Button type='submit' onClick={manageDDCSubject}>
								Submit
							</Button>
						</div>

						{showDetails && (
							<div className='mt-6 text-center space-y-2'>
								<img src={student.photo} alt='Student' className='mx-auto h-52 w-52 rounded-full object-cover border-2 border-gray-300' />
								<p className='text-lg font-semibold text-gray-800 dark:text-white'>Name: {student.name}</p>
							</div>
						)}
					</div>
				</div>

				<div className='w-2/3'>
				<Body height='90vh'>
  <div ref={componentRef} className='printable'>
    <div className='w-full overflow-x-auto rounded-[25px] p-[1%]'>
      <div className='min-w-[750px] flex flex-col'>
        <h5 className='text-[30px] w-full m-0 self-center dark:text-slate-100'>PrintsFoots</h5>

        <Table width='100%' innerWidth={['5%', '15%', '30%', '20%', '10%', '10%']}>
          <Thead>
            <Tr>
              <Th position={0} textAlign='center'>Sn</Th>
              <Th position={1}>Admn No</Th>
              <Th position={2}>Name</Th>
              <Th position={3}>Class/Dept</Th>
              <Th position={4}>Date</Th>
              <Th position={5}>Time</Th>
            </Tr>
          </Thead>

          <Tbody height='65vh'>
            {filteredData?.map((item, i) => (
              <Tr key={i} index={i}>
                <Td position={0} index={i} textAlign='center'>{i + 1}</Td>
                <Td position={1} index={i}>{item.admisionNo}</Td>
                <Td position={2} index={i}>{item.name}</Td>
                <Td position={3} index={i}>{item.classDept}</Td>
                <Td position={4} index={i}>{item.date}</Td>
                <Td position={5} index={i}>{item.time}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    </div>
  </div>
</Body>

				</div>
			</div>
		</Main>
	);
};
